import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormControl } from "@angular/forms";

import { TopicFormService } from "../../services/topic-form.service";

import {
  BLACKLIST_COUNTRIES_DEFAULT,
  WHITELIST_COUNTRIES_DEFAULT
} from "../topic-write-form.component";
import {
  countriesList,
  Country,
  CountryAvailabilityType
} from "@onsip/common/interfaces/countries-list";
import { TranslateService } from "@ngx-translate/core";

interface ListPickerItem {
  id: string;
  name: string;
  avatarUrl: string;
}

@Component({
  selector: "onsip-country-picker",
  styleUrls: ["./country-picker.scss"],
  templateUrl: "./country-picker.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CountryPickerComponent implements OnChanges {
  @Input() initialValue: Array<string> = []; // an array of country codes
  @Input() disabled = false;
  @Output() formInit = new EventEmitter<FormControl>();

  allCountries: Array<ListPickerItem>;
  initialCountries: Array<ListPickerItem> = [];
  formControl = new FormControl(); // shared
  private _countryAvailabilityStrategy: CountryAvailabilityType = "whitelist";

  @Input() set countryAvailabilityStrategy(countryAvailabilityStrategy: CountryAvailabilityType) {
    this._countryAvailabilityStrategy = countryAvailabilityStrategy;
    if (countryAvailabilityStrategy === "whitelist") {
      this.topicForm.removeControl("blacklistCountries");
      this.formControl.setValue(
        this.allCountries.filter(country =>
          WHITELIST_COUNTRIES_DEFAULT.find(code => code === country.id)
        )
      );
      this.topicForm.addControl("whitelistCountries", this.formControl);
    } else {
      this.topicForm.removeControl("whitelistCountries");
      this.formControl.setValue(
        this.allCountries.filter(country =>
          BLACKLIST_COUNTRIES_DEFAULT.find(code => code === country.id)
        )
      );
      this.topicForm.addControl("blacklistCountries", this.formControl);
    }
  }

  get countryAvailabilityStrategy() {
    return this._countryAvailabilityStrategy;
  }

  constructor(private topicForm: TopicFormService, private translate: TranslateService) {
    this.allCountries = countriesList.map((country: Country) => ({
      name: this.translate.instant(`ONSIP_I18N.COUNTRY_CODE.${country.code}`),
      id: country.code,
      avatarUrl: `resources/img/country_flags/${country.code}.png`
    }));

    this.topicForm.addControl("whitelistCountries", this.formControl);
  }

  ngOnChanges() {
    this.formControl.setValue(
      this.allCountries.filter(country => this.initialValue.find(code => code === country.id))
    );
  }
}
